<template>
  <div class="hj-footer">
    <el-row>
      <!-- :offset="3" -->
      <el-col :span="3">
        <div><img src="../../assets/img/home/logo-footer.png" /></div>
      </el-col>
      <el-col :span="3">
        <h2>友情链接</h2>
        <div class="footer-menu-list">
          <div class="footer-menu" @click="handleSelect('aboutUs')">关于我们</div>
          <div class="footer-menu text-right" @click="handleSelect('usinessPartner')">合作伙伴</div>
          <div class="footer-menu" @click="handleSelect('companyDevelopt')">公司荣誉</div>
          <div class="footer-menu text-right" @click="handleSelect('joinUs')">联系我们</div>
          <div class="footer-menu" @click="handleSelect('productIntroduction')">产品介绍</div>
        </div>
      </el-col>
      <el-col :span="5">
        <h2>联系我们</h2>
        <div class="contact-us-row">电话：021-50112219</div>
        <div class="contact-us-row">邮箱：service@insuresmart.com.cn</div>
        <div class="contact-us-row">总部地址：上海市浦东新区金海路1000号26号楼12层</div>
        <div class="contact-us-row">分部： <span class="pl30">合肥 </span><span class="pl30">西安</span></div>
        <!--        <div class="contact-us-row">西安分公司地址：西安市雁塔区科技二路65号K座703室</div>
        <div class="contact-us-row">宁波分公司地址：宁波市鄞州区翔云北路99号9号楼5-1-6</div>-->
      </el-col>
      <el-col :span="7">
        <h2>荣誉资质</h2>
        <div class="contact-us-row">Copyright©2025 因朔桔（上海）智能科技有限公司 All rights reserved.</div>
        <div class="contact-us-row">营业执照：统一社会信用代码 91310110MA1G8T1D9U</div>
        <div class="contact-us-row">医疗机构执业许可证： 登记号 MAE94FHU751011619A1002</div>
        <div class="contact-us-row">互联网药品信息服务资格证书：（沪）-经营性-2022-0147</div>
        <div class="contact-us-row">因朔桔旗下全资互联网医院：成都双流因朔桔互联网医院</div>
        <div class="contact-us-row">互联网医院三级等保证书编号：51010045548-25001</div>
      </el-col>
      <el-col :span="3">
        <img src="../../assets/img/home/ysj.jpg" height="150" />
        <div style="line-height: 40px; margin-left: 40px">官方公众号</div>
      </el-col>
    </el-row>
    <div style="width: 100%; margin: 0 auto; padding: 20px 0 0; display: flex; justify-content: center">
      <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index" style="display: inline-block; text-decoration: none; height: 20px; line-height: 20px"
        ><img src="" style="float: left" />
        <p style="float: left; height: 20px; line-height: 20px; margin: 0px 0px 0px 5px; color: #939393">ICP备案许可证号 沪ICP备18034148号-9</p></a
      >
      <a target="_blank" href="https://beian.mps.gov.cn/#/query/webSearch?code=31011502403366" style="display: inline-block; text-decoration: none; height: 20px; line-height: 20px; margin-left: 20px"
        ><img src="../../assets/img/home/gongan.png" style="width: 16px; height: 16px;float: left" />
        <p style="float: left; height: 20px; line-height: 20px; margin: 0px 0px 0px 5px; color: #939393">沪公网安备 31011502403366号</p>
      </a>
    </div>
    <!--        <el-divider></el-divider>
            <el-row style='font-size: 12px;'>
              <div style='padding-bottom: 10px;'>©2018-2023 因朔桔（上海）科技有限公司版权所有
                <span style="margin-left: 30px">
                  <a target="_blank" href='https://beian.miit.gov.cn' style='color: #ffffff'>沪ICP备18034148号</a>
                </span>
                <span style="margin-left: 30px">
                   <a style='color: #ffffff' target="_blank"
                      href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502018318">
                     沪公网安备 31011502018318号
                   </a>
                </span>
              </div>
            </el-row>-->
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {}
  },
  methods: {
    handleSelect(key) {
      console.log(key)
      let path = `/pc/` + key
      this.$router.push({ path: path })
    }
  }
}
</script>

<style lang="scss" scoped>
.hj-footer {
  padding: 2rem 0 1rem;
  background-color: #333333;
  color: #ffffff;
  text-align: left;
  font-size: 16px;
  .el-row {
    display: flex;
    justify-content: space-evenly;
  }

  h2 {
    line-height: 60px;
    font-size: 20px;
  }

  .footer-menu-list {
    width: 180px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .footer-menu {
    text-align: left;
    line-height: 3;
    cursor: pointer;
    // width: 100px;
  }

  .text-right {
    text-align: right;
  }

  .contact-us-row {
    line-height: 35px;
  }
}
</style>
